import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigTypes } from '@api/configurationTemplates';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_CONFIG_TYPES } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesConfigTypes {
	configTypes: TSelectOption<string>[];
	isLoadingConfigTypes: boolean;
}

const useQueryConfigurationTemplatesConfigTypes = (): IUseQueryConfigurationTemplatesConfigTypes => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_CONFIG_TYPES],
		queryFn: getConfigurationTemplateConfigTypes,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
			additionalMappings: {
				name: 'name',
				title: 'title',
			},
			preserveZeroValue: true,
		}),
		enabled: [],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configTypes: data || [],
		isLoadingConfigTypes: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesConfigTypes;
